module.exports = __webpack_public_path__ + "static/media/WhiteHart2026XmasMenu.47759f16.pdf";